import React, { useState } from 'react';
import { BsTwitter, BsInstagram, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF } from 'react-icons/fa';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me ☎️</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:zeufackjojo@yahoo.fr" className="p-text">zeufackjojo@yahoo.fr</a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+1 (123) 456-7890" className="p-text">+39 3357669018</a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )}
      {/* <!-- START THE COPYRIGHT INFO  --> */}
      <div className="app__footer-cards">
        <div className="container">
          <div className="row text-center text-white">
            <div className="col-12">
              <div claclassName="footer-bottom__copyright">
                <a href="https://www.linkedin.com/in/zeufack-jojo-2a523935/" target="_blank" rel="noreferrer">©Copyright 2022 Multi-purpose Company | Created by Zeufi</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- START THE SOCIAL MEDIA CONTENT  --> */}
      <div className="app__socials ml-1">
        <p>Connect with me on social media </p>
        <div>
          <a href="https://www.linkedin.com/in/zeufack-jojo-2a523935/" target="_blank" rel="noreferrer">
            <BsLinkedin />
          </a>
        </div>
        <div>
          <a href="https://www.facebook.com/jojo.songoa" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </a>
        </div>
        <div>
          <a href="https://www.instagram.com/zeufi1/" target="_blank" rel="noreferrer">
            <BsInstagram />
          </a>
        </div>
        <div>
          <a href="https://twitter.com/Zeufi01" target="_blank" rel="noreferrer">
            <BsTwitter />
          </a>
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__whitebg',
);
